import './WelcomePage.scss';
import React from 'react';
import { Outlet } from 'react-router';
import { Translation } from "react-i18next";
import { Button, Image, } from "semantic-ui-react";

import { WelcomePageSidebar } from "./welcomePageSidebar/WelcomePageSidebar";

import image01 from "../../images/004-ima.jpg";
import image02 from "../../images/002-ima.jpg";
import image03 from "../../images/003-ima.jpg";
import { Link } from 'react-router-dom';

export const WelcomePage = () => {

    const mainRef = React.useRef<HTMLDivElement>(null);

    return (
        <div className="welcome-page" ref={mainRef}>
            <div className="welcome-page-inner-wrapper">
                <Translation>
                    {
                        t =>
                            <>
                                <div className="welcome-page__header-background-img">
                                    <div className="welcome-page__header-title-container">
                                        <h1 className="welcome-page__header-title">
                                            Los Angeles County Watershed Reporting System
                                        </h1>
                                        <p className="welcome-page__header-subtitle">
                                            WRAMPS is the home for reporting progress toward watershed-based regulatory  requirements and proactive water capture goals in LA County.
                                        </p>
                                    </div>
                                    <div className="white-wave-wrapper">
                                        <div className="white-wave"></div>
                                    </div>
                                </div>
                                <div className="welcome-page__cards-container">
                                    <WelcomePageCard
                                        location="/progress-reporting"
                                        title="Progress Reporting"
                                        category={<>Transparent, readily-understandable summaries of water quality improvement progress by municipalities as required by the MS4 Permit. <br /><br />Updates are provided every 6 months!</>}
                                        image={image01}
                                        buttonLabel="View Progress" />

                                    <WelcomePageCard
                                        location="/capture"
                                        title="Capture"
                                        category={<> Real-time summaries of stormwater capture across the County by green infrastructure and water conservation facilities.<br /><br />Check the dashboard after each storm! </>}
                                        image={image02}
                                        buttonLabel="Explore Capture" />

                                    <WelcomePageCard
                                        location="/cobenefits"
                                        title="Co-benefits"
                                        category={<>Summaries of multiple co-benefits provided to the community by stormwater programs.</>}
                                        image={image03}
                                        buttonLabel="See Co-benefits" />
                                </div>
                                <div className="small-device-message">Please visit this page from a larger device</div>
                                <div className="tab-div">
                                    <div className="tab">
                                        <Outlet />
                                    </div>
                                </div>
                            </>
                    }
                </Translation>
                <WelcomePageSidebar />
                <div className="footer-wave-wrapper">
                    <div className="blue-wave">
                        <div className="wave-background"></div>
                        <div className="wave-filler"></div>
                        <p className="welcome-page__footer-text">© {new Date().getFullYear()} Los Angeles County Watershed Reporting System</p>
                    </div>
                </div>
            </div >
        </div >
    )
}

type WelcomePageCardProps = {
    location: string,
    title: React.ReactElement | string,
    category: React.ReactElement | string,
    buttonLabel: React.ReactElement | string,
    image: string
}
function WelcomePageCard(props: WelcomePageCardProps) {
    return (
        <div>
            <section className="welcome-page-cards">
                <Link
                    className="welcome-page-card"
                    to={props.location}>
                    <Image src={props.image} size='medium' />
                    <div className="welcome-page__card__info">
                        <h3 className="welcome-page__card__title">{props.title}</h3>
                        <p className="welcome-page__card__category">
                            {props.category}
                        </p>
                        <Button
                            primary
                            size="massive"
                            className="welcome-page__card-btn"
                        >
                            <Button.Content visible>{props.buttonLabel}</Button.Content>
                        </Button>
                    </div>
                </Link>
            </section>
        </div>
    )
}
